import {
  EGraphType,
  fetchGetGraphData,
  IGetGraphDataResponse200,
  IGetGraphDataResponse400,
  IGetGraphDataResponse,
} from '../../repositories/valuation-b2b/v1/get-graph-data';
import { TThunkDispatch, IApplicationState, IThunkContext, TRegionGraph, TGraphValuesType } from '../../types/redux';
import { actionTypes } from '../../constants/actionTypes';

export interface IGraphsSetDataAction {
  type: actionTypes.SET_GRAPHS_DATA;
  payload: IGetGraphDataResponse;
}

export interface IGraphsSetLoadingAction {
  type: actionTypes.SET_GRAPHS_LOADING;
}

export interface IGraphToggleRegionAction {
  type: actionTypes.TOGGLE_REGION_GRAPH;
  payload: TRegionGraph;
}

export interface IGraphToggleGraphValuesTypeAction {
  type: actionTypes.TOGGLE_GRAPH_VALUES_TYPE;
  payload: TGraphValuesType;
}

export type TGraphsActions =
  | IGraphsSetDataAction
  | IGraphsSetLoadingAction
  | IGraphToggleRegionAction
  | IGraphToggleGraphValuesTypeAction;

export function setGraphsData(data: IGetGraphDataResponse): IGraphsSetDataAction {
  return {
    type: actionTypes.SET_GRAPHS_DATA,
    payload: data,
  };
}

export function setGraphsLoading(): IGraphsSetLoadingAction {
  return {
    type: actionTypes.SET_GRAPHS_LOADING,
  };
}

export function toggleGraphRegion(regionGraph: TRegionGraph): IGraphToggleRegionAction {
  return {
    type: actionTypes.TOGGLE_REGION_GRAPH,
    payload: regionGraph,
  };
}

export function toggleGraphValuesType(valuesType: TGraphValuesType): IGraphToggleGraphValuesTypeAction {
  return {
    type: actionTypes.TOGGLE_GRAPH_VALUES_TYPE,
    payload: valuesType,
  };
}

export function getGraphs(graphType: EGraphType) {
  return (dispatch: TThunkDispatch, getState: () => IApplicationState, context: IThunkContext) => {
    const timeout = context.config.get<number>('valuationB2bGetGrapsTimeout') || 3000;

    dispatch(setGraphsLoading());

    return fetchGetGraphData<IGetGraphDataResponse200, IGetGraphDataResponse400>({
      httpApi: context.httpApi,
      parameters: { graphType },
      config: {
        ecnhancersConfig: { timeout },
      },
    })
      .then(response => {
        if (response.statusCode === 200) {
          dispatch(setGraphsData(response.response));

          return;
        }
      })
      .catch(e => {
        context.logger.warning(e, { mesasge: 'Can not get data for graphs. Users not affect.' });
      });
  };
}
